import { createSelector, type MemoizedSelector } from '@ngrx/store';
import type { CoreApiToken } from '../../../shared';
import type { SessionId } from '../../services/auth/auth.interface';
import type { RosaCoreState } from '../core.state';
import type { State } from './auth.state';

const getToken = (state: State): CoreApiToken | null => (state ? state.token : null);
const getIsAuthenticated = (state: State): boolean => state.isAuthenticated;
const getIsConnectedAs = (state: State): boolean => state.isConnectedAs;
const getIsPending = (state: State): boolean => state.isPending;
const getIsCguAccepted = (state: State): boolean | null =>
    state?.token?.authorities.includes('has_cgu_accepted') ?? null;
const getIsPasswordExpired = (state: State): boolean => state?.token?.has_password_expired ?? false;
const getSessionId = (state: State): SessionId | null => state?.sessionId ?? null;

export const selectAuthState: MemoizedSelector<RosaCoreState, State> = createSelector(
    state => state['auth'],
    value => value
);

export const selectToken: MemoizedSelector<RosaCoreState, CoreApiToken | null> = createSelector(
    selectAuthState,
    getToken
);
export const selectIsAuthenticated: MemoizedSelector<RosaCoreState, boolean> = createSelector(
    selectAuthState,
    getIsAuthenticated
);
export const selectIsConnectedAs: MemoizedSelector<RosaCoreState, boolean> = createSelector(
    selectAuthState,
    getIsConnectedAs
);
export const selectIsPending: MemoizedSelector<RosaCoreState, boolean> = createSelector(selectAuthState, getIsPending);
export const selectIsCguAccepted: MemoizedSelector<RosaCoreState, boolean | null> = createSelector(
    selectAuthState,
    getIsCguAccepted
);
export const selectIsPasswordExpired: MemoizedSelector<RosaCoreState, boolean> = createSelector(
    selectAuthState,
    getIsPasswordExpired
);
export const selectSessionId: MemoizedSelector<RosaCoreState, SessionId | null> = createSelector(
    selectAuthState,
    getSessionId
);
